import axios from 'axios';
import _ from 'lodash';
import DomainNameAPI from '../constants/DomainNameAPI';
import LoginService from '../utils/login-service';
import Topics from '../constants/Topics';
import Constants from '../constants/Constants';
import ReactDOM from 'react-dom';

const variEnv = process.env.REACT_APP_STAGE;
const api_save_tc_base_url = DomainNameAPI[variEnv].SAVE_TC_SERVICE_BASEURL;
const apiError = Constants.API_SERVER_ERROR;
// const roleError = "You do not have appropriate role to access this site. Please <a href='${contact_us}'>Contact Us</a> to update your credentials."
// const contact_us = DomainNameAPI.CONTACT_US_URL;
// var appDiv = $('#root');

// function showError(err) {
//   appDiv.css({ 'margin-left': '40px' });
//   appDiv.html(
//     `<h4>You do not have appropriate role to access this site. Please <a href='${contact_us}'>Contact Us</a> to update your credentials.</h4>`
//   );
// }

export const saveTerms = async (argsObject) => {
  if (_.isNil(argsObject.orgId || _.isNil(argsObject.year))) {
    throw new Error('saveTerms call requires that orgId CANNOT be undefined or null');
  }
  if (_.isNil(LoginService)) {
    throw new Error('CBSESSION IS UNDEFINED');
  }
  let cbSession = LoginService.getTokens();
  if (!cbSession.isLoggedIn) {
    throw new Error('getTerms is called when user is not logged in');
  }
  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });
  const TARGET_SAVE_SERVICE_URL = api_save_tc_base_url + 'orgId=' + argsObject.orgId;
  let termsConditions = {
    orgId: parseInt(argsObject.orgId),
    year: parseInt(argsObject.year),
    accepted: true,
    acceptedDate: new Date().toISOString(),
  };
  return axios({
    method: 'PUT',
    url: TARGET_SAVE_SERVICE_URL,
    timeout: 10000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
    data: JSON.stringify(termsConditions),
  })
    .then((res) => {
      argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
      return {
        acAccepted: true,
        toDashboard: true,
        isLoading: false,
      };
    })
    .catch((err) => {
      console.log(`TERMS ERROR: ${err}`);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};

export const getTerms = async (argsObject) => {
  if (_.isNil(argsObject.Api)) {
    throw new Error('getTerms call requires an Api');
  }
  if (_.isNil(LoginService)) {
    throw new Error('CBSESSION IS UNDEFINED');
  }

  if (_.isNil(argsObject.orgId)) {
    // showError();
    return;
  }

  //argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });

  // var logger = cb.core.utils.Logger.getLogger('MyAWSStuffApp');

  var cbSession = LoginService.getTokens();
  if (!cbSession.isLoggedIn) {
    // logger.error('getEventRoster() is called when user is not logged in');
    return;
  }

  //var iamToken = cb.core.iam.getJWTToken();
  //   var roleOrgsList = JSON.parse(atob(iamToken.split('.')[1])).cb.ro;
  //   // Find the roleOrgItem that with needAnalysisRole to get it login and check Terms & Condition
  //   let roleOrgItem = _.find(roleOrgsList, ['rid', "804"]);
  var variEnv = process.env.REACT_APP_STAGE;
  var api_tc_base_url = DomainNameAPI[variEnv].SAVE_TC_SERVICE_BASEURL;

  //let orgData = ServiceCaller({ serviceType: "GETORGID", argsObject: {} });
  var TARGET_SERVICE_URL = `${api_tc_base_url}orgId=${argsObject.orgId}&year=${process.env.REACT_APP_YEAR}&cutDate=${argsObject.cutOffDate}`;
  // logger.debug('calling target service:' + TARGET_SERVICE_URL);
  return axios({
    method: 'GET',
    url: TARGET_SERVICE_URL,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then(({ data }) => {
      let tcval = false;
      {
        data && data.accepted ? (tcval = true) : (tcval = false);
      }

      argsObject.Api.Publish(Topics.TERMS_DATA, { acAccepted: tcval, toDashboard: tcval });
      //argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
    })
    .catch(() => {
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};
